import { useState, useId } from "react";
import CandidateListModal from "../candidates/CandidateListModal";

interface CandidateMessageWrapperProps {
  jdPath: string;
  children: React.ReactNode;
}

export function CandidateMessageWrapper({
  jdPath,
  children,
}: CandidateMessageWrapperProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const gradientId = useId();

  return (
    <>
      <div className="flex flex-col gap-2.5 mt-1">
        {/* Candidate results content */}
        <div className="w-full min-w-0">
          {children}
        </div>
        {/* "View Full List" button */}
        <div className="rounded-full bg-gradient-to-r from-gradient-start to-gradient-end p-px self-start">
          <button
            type="button"
            onClick={() => setModalOpen(true)}
            aria-label="View Full List"
            className="flex items-center gap-1.5 rounded-full bg-white px-4 py-2 transition-colors hover:bg-grey-25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 cursor-pointer"
          >
            <span className="bg-gradient-to-r from-gradient-start to-gradient-end bg-clip-text text-body-sm lg:text-body-md font-semibold tracking-tight text-transparent">
              View Full List
            </span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <defs>
                <linearGradient id={gradientId} x1="0" y1="0" x2="16" y2="16">
                  <stop stopColor="#FF3072" />
                  <stop offset="1" stopColor="#750087" />
                </linearGradient>
              </defs>
              <path
                d="M3.333 8H12.667M12.667 8L8.667 4M12.667 8L8.667 12"
                stroke={`url(#${gradientId})`}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      {modalOpen && (
        <CandidateListModal
          jdPath={jdPath}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
